import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import LawDetail from './LawDetail';
import Layout from './Layout.js';
import ErrorBoundary from './Components/ErrorBoundary';
import ScrollToTop from './Components/ScrollToTop';

import DpdpActFullText from './pages/DpdpActFullText';
import Blog from './pages/Blog.jsx';
import ContactUs from './pages/ContactUs.jsx';
import NotFound from './pages/NotFound.jsx';

// Initialize Google Analytics
// Your Measurement ID from Google Analytics
const GA_MEASUREMENT_ID = 'G-GE83JHCGFV';

// Only initialize if measurement ID is set and not placeholder
if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

// Track page views when route changes
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname + location.search
      });
    }
  }, [location]);
  
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <RouteTracker />
        <ScrollToTop />
        <Routes>
        {/* Redirect root to DPDP Act by default */}
        <Route path="/" element={<Navigate to="/dpdp" replace />} />
        {/* Backwards-compatible redirects for old/capitalized paths */}
        <Route path="/LawDetail" element={<RedirectToLawDetail />} />
        <Route path="/Lawdetail" element={<RedirectToLawDetail />} />
        {/* DPDP Rules tab: You can point this to a specific component or LawDetail with a different lawType if needed */}
        <Route path="/dpdp-rules" element={<Layout currentPageName="LawDetail"><LawDetail lawType="dpdp-rules" /></Layout>} />
        {/* DPDP Act tab */}
        <Route path="/dpdp" element={<Layout currentPageName="LawDetail"><LawDetail lawType="dpdp" /></Layout>} />
        <Route path="/law-detail" element={<Layout currentPageName="LawDetail"><LawDetail /></Layout>} />
        {/* Full DPDP Act Markdown page */}
        <Route path="/dpdp-act-full" element={<DpdpActFullText />} />
        {/* Blog tab */}
        <Route path="/blog" element={<Layout currentPageName="Blog"><Blog /></Layout>} />
        {/* Contact Us tab */}
        <Route path="/contact-us" element={<Layout currentPageName="ContactUs"><ContactUs /></Layout>} />
        {/* 404 - Catch all unknown routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
    </ErrorBoundary>
  );
}

export default App;

function RedirectToLawDetail() {
  const { search } = useLocation();
  return <Navigate to={`/law-detail${search}`} replace />;
}